import { Component, OnInit, ErrorHandler } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RegistrationService } from '../../../registration.service';
import swal from 'sweetalert2';

@Component({
  selector: 'app-pension-issuing-authority-grid',
  templateUrl: './pension-issuing-authority-grid.component.html',
  styleUrls: ['./pension-issuing-authority-grid.component.css']
})
export class PensionIssuingAuthorityGridComponent implements OnInit {
  maintitle="Pension Issuing Authority";
  title = "View Pension Issuing Authority";
  itemsPerPage:number=5;
  currentPage: number=1;
  PIAList: any=[];
  totalItems: any;
  s:any={};
  constructor(private route: ActivatedRoute,private errorHandler:ErrorHandler,private userService: RegistrationService) { }

  ngOnInit() {
    this.GetAllPIAForMasters(this.itemsPerPage, 1);
  }


  
  SetUrl(PIA_Id:any,mode:any)
  {
    localStorage.setItem('PIA_Id',PIA_Id);
    localStorage.setItem('mode', mode);
  }

  pageChanged(pageNumber: number) {
    
    //if (this.isSearch)
     // this.onSearch(this.s, this.itemsPerPage, pageNumber);
    //else
      this.GetAllPIAForMasters(this.itemsPerPage, pageNumber);
  }

  itemsPerPageChanged(itemsPerPage: number, pageNo: number) {
    // if (this.isSearch)
    //   this.onSearch(this.s, this.itemsPerPage, pageNo);
    // else
      this.GetAllPIAForMasters(this.itemsPerPage, pageNo);
  }


  GetAllPIAForMasters(itemsPerPage: number, pageNo: number) {
    
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.getAllPIAForMasters(itemsPerPage, pageNo)
      .subscribe(
        (data: any) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.PIAList = data.PIAList;
          this.totalItems = data.TotalItemsCount;
          this.itemsPerPage = itemsPerPage;
          this.currentPage = pageNo;
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.handleError(error);
        });
  }


  DeletePensionIssuingAuthorityDetails(PIA_Id:any)
  {
    
    swal({
      title: 'Are you sure?',
      text: "You want to delete this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.value) {
        document.getElementById('loader-spinner').style.display = "block";
        this.userService.deletePensionIssuingAuthorityDetails(PIA_Id).subscribe(
          (data:any) => {
            swal('','Issuing Authority details has been Deleted!','success');
            this.GetAllPIAForMasters(this.itemsPerPage, 1);
            this.s.SearchText = "";
            this.s.SearchCriteria = "";
          },(error) => {
            document.getElementById('loader-spinner').style.display="none";
            this.errorHandler.handleError(error);
          });
      }
    })  
  }




}



// WEBPACK FOOTER //
// ./src/app/Masters/pension-issuing-authority/pension-issuing-authority-grid/pension-issuing-authority-grid.component.ts